// extracted by mini-css-extract-plugin
module.exports = {"timer":"styles_timer__3thNU"};